import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';
import Common from '../Common/common.js';

class WaitingStatus extends Component {

  constructor(props) {
    super(props);
    this.state = {
      shopId: isFinite(props.match.params.shopId) ? props.match.params.shopId : null,
      wait_count: null,
      open_data: null,
      ready: false,
      error: false,
    };
    this.settings = [];
    this.logo = null;
    this.entryOptions = [];
    this.refresh = this.refresh.bind(this);
  }

  async componentDidMount() {
    if (!this.state.shopId) {
      this.setState({ error: true });
      return;
    }
    try {
      const reg_params = {
        "operator": "and",
        "where": [{ "shop_id": this.state.shopId }]
      };
      this.settings = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/setting/search/`, reg_params)).data;
      const logo_file = Common.getSettingValue(this.settings, 'LOGO_FILE', '');
      if (logo_file) {
        this.logo = (process.env.REACT_APP_ENV === 'pro' ? '' : process.env.REACT_APP_AWS_FRONTEND_URL)
          + constClass.LOGO_IMAGE_DIR + logo_file;
        this.logoFile = logo_file;
      }
      console.log(this.logo);
      console.log(this.logoFile);
      const entryCountType = Common.getSettingValue(this.settings, constClass.SETTING.ENTRY_COUNT, '');
      if (entryCountType) {
        try {
          const entryTypeParams = {
            "operator": "and",
            "where": [{ "shop_id": this.state.shopId }, { "entry_type": entryCountType }]
          };
          const entryTypes = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/entry_type/search/`, entryTypeParams)).data;
          const matched = entryTypes.find(t => t.entry_type === entryCountType);
          this.entryOptions = matched
            ? (matched.m_entry_data || []).filter(d => d.entry_data !== null).sort((a, b) => a.entry_seq - b.entry_seq)
            : [];
        } catch (e) {
          this.entryOptions = [];
        }
      }
    } catch (err) {
      this.setState({ error: true });
      return;
    }
    await this.refresh();
    this.intervalId = setInterval(this.refresh, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  async refresh() {
    try {
      const entryCountType = Common.getSettingValue(this.settings, constClass.SETTING.ENTRY_COUNT, '');
      let wait_count, open_data;
      if (entryCountType) {
        const data = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/order/entrycount/${this.state.shopId}`)).data;
        const rawCounts = data.counts || [];
        if (this.entryOptions.length > 0) {
          wait_count = this.entryOptions.map(opt => {
            const found = rawCounts.find(c => c.entry_data === opt.entry_data);
            return { entry_data: opt.entry_data, entry_name: opt.entry_name, count_order: found ? Number(found.cnt) : 0 };
          });
        } else {
          wait_count = rawCounts.map(c => ({ entry_data: c.entry_data, entry_name: c.entry_name, count_order: c.cnt }));
        }
        open_data = data.open_data;
      } else {
        const data = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/order/count/${this.state.shopId}`)).data;
        wait_count = data.wait_count;
        open_data = data.open_data;
      }
      this.setState({
        wait_count,
        open_data,
        ready: true,
        error: false,
      });
    } catch (err) {
      this.setState({ error: true });
    }
  }

  renderCount(isOpen, waitCount, waitCountList, labelWait, labelUnit, labelWaitClose, hasEntryCount) {
    return (
      <div className="ws-count-card">
        {isOpen &&
          <p className="ws-count-label">{labelWait}</p>
        }
        {this.state.error ? (
          <p className="ws-error-text">情報を取得できませんでした</p>
        ) : isOpen ? (
          hasEntryCount && waitCountList.length > 0 ? (
            <div className="ws-entry-count-list">
              <div className="ws-entry-count-row ws-entry-count-row--total">
                <span className="ws-entry-count-name">合計</span>
                <div className="ws-count-wrap">
                  <span className="ws-count-num ws-count-num--sm">
                    {Number(waitCountList.reduce((sum, item) => sum + (item.count_order || 0), 0))}
                  </span>
                  <span className="ws-count-unit">{labelUnit}</span>
                </div>
              </div>
              {waitCountList.map((item, i) => (
                <div key={i} className="ws-entry-count-row">
                  <span className="ws-entry-count-name">{item.entry_name || item.entry_data}</span>
                  <div className="ws-count-wrap">
                    <span className="ws-count-num ws-count-num--sm">{item.count_order}</span>
                    <span className="ws-count-unit">{labelUnit}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="ws-count-wrap">
              <span className="ws-count-num">{waitCount}</span>
              <span className="ws-count-unit">{labelUnit}</span>
            </div>
          )
        ) : (
          <p className="ws-closed-text">{labelWaitClose}</p>
        )}
      </div>
    );
  }

  renderNotice(notice1, notice2, noticeImageUrl) {
    if (!notice1 && !notice2 && !noticeImageUrl) return null;
    return (
      <div className="ws-notice-card">
        <p className="ws-notice-title">お知らせ</p>
        {noticeImageUrl && (
          <div className="ws-notice-image-wrap">
            <img src={noticeImageUrl} alt="お知らせ" className="ws-notice-image" />
          </div>
        )}
        {notice1 && <p className="ws-notice-text">{notice1}</p>}
        {notice2 && <p className="ws-notice-text">{notice2}</p>}
      </div>
    );
  }

  render() {
    if (!this.state.ready && !this.state.error) {
      return <Loading />;
    }

    const titleName = Common.getSettingValue(this.settings, 'TITLE_NAME', '順番待ち');
    const labelWait = Common.getSettingValue(this.settings, 'LABEL_WAIT_COUNT', '現在の待ち人数');
    const labelUnit = Common.getSettingValue(this.settings, 'LABEL_WAIT_COUNT_UNIT', '人');
    const labelWaitClose = Common.getSettingValue(this.settings, constClass.SETTING.LABEL_WAIT_CLOSE, '受付停止中');
    const notice1 = Common.getSettingValue(this.settings, 'MESSAGE_WAITING_1', '');
    const notice2 = Common.getSettingValue(this.settings, 'MESSAGE_WAITING_2', '');
    const noticeImageUrl = Common.getSettingValue(this.settings, 'NOTICE_IMAGE_URL', '');
    const entryCountType = Common.getSettingValue(this.settings, constClass.SETTING.ENTRY_COUNT, '');
    const hasEntryCount = !!entryCountType;
    const isOpen = this.state.open_data && this.state.open_data.open_wait_flg === constClass.OPEN;
    const waitCountList = this.state.wait_count || [];
    const waitCount = waitCountList.find(x => true) ? waitCountList.find(x => true).count_order : 0;
    const hasNotice = !!(notice1 || notice2 || noticeImageUrl);

    return (
      <div className="ws-page">
        <header className="ws-header">
          <span className="ws-header-text">{titleName}</span>
        </header>

        <div className="ws-body">
          {this.logo && (
            <div className="ws-logo-wrap">
              <img src={this.logo} alt="ロゴ" className="ws-logo" onError={e => { try { e.target.src = require(`../Images/${this.logoFile}`).default; e.target.onerror = () => { e.target.style.display = 'none'; }; } catch { e.target.style.display = 'none'; } }} />
            </div>
          )}

          {hasNotice ? (
            <div className="ws-two-col">
              {this.renderCount(isOpen, waitCount, waitCountList, labelWait, labelUnit, labelWaitClose, hasEntryCount)}
              {this.renderNotice(notice1, notice2, noticeImageUrl)}
            </div>
          ) : (
            this.renderCount(isOpen, waitCount, waitCountList, labelWait, labelUnit, labelWaitClose, hasEntryCount)
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(WaitingStatus);